module.exports = __webpack_public_path__ + "img/additional_btn.c72f3c06.png";